import tarotResultChange from './actions/tarotResultChange';
import tarotResultCreate from './actions/tarotResultCreate';
import tarotResultDetail from './actions/tarotResultDetail';
import tarotResultsList from './actions/tarotResultsList';
import getTarotResults from './getters/getTarotResults';
import tarotResultsUpload from './mutations/tarotResultsUpload';

const actions = {
    tarotResultChange,
    tarotResultCreate,
    tarotResultDetail,
    tarotResultsList
};

const mutations = {
    tarotResultsUpload
};

const getters = {
    getTarotResults
};

export default { actions, mutations, getters };
